<template lang="html">
  <info-icon
    :icon="icon"
    :color="color"
    :message="message"/>
</template>

<script>
import InfoIcon from './InfoIcon';
export default {
  components: {
    'info-icon': InfoIcon
  },
  data: () => ({
    icon: 'mdi-bus-clock',
    color: 'warning',
    message: 'Trip date is within 5 days'
  })
}
</script>

<style lang="css" scoped>
</style>
